import React from 'react'
import { t } from 'ttag'

import { ExportResourceModal } from 'components/modals/common/ExportResourceModal/ExportResourceModal'

import { useExportJobsData } from './hooks'

export const ExportJobsModal = ({ onCancel, onClose, isOpen }) => {
  const { state, handlers } = useExportJobsData()

  const { data } = state
  const { handleExportCSV, handleExportXLXS } = handlers

  return (
    <ExportResourceModal
      message={t`You can export the data as a CSV file or a XLSX file.`}
      title={t`Export jobs`}
      onExportCSV={handleExportCSV}
      onExportXLSX={handleExportXLXS}
      {...{ data, onCancel, onClose, isOpen }}
    />
  )
}
